module.exports = __webpack_public_path__ + "static/media/orange.2412b328.png";